import React, { useState } from "react";
import { RichTreeView } from "@mui/x-tree-view/RichTreeView";
import { Box } from "@mui/material";
import configtreejson from "../Tempdata/ConfigTreejson";
import { useDispatch, useSelector } from "react-redux";
import { updateconfigtreepathselected } from "../store/cofig_data";

// 1. Map pagename to permission code
const pagePermissionMap = {
  General: "PJGC23",
  AlertConfiguration: "PJNC36",
  AlertGeneralConfiguration: "PJNC36",
  TemplateGroup: "PRTC59",
  Template: "PRTC59",
  TemplateConfigurator: "PRTC59",
  Scheduler: "PRTC59",
  SystemSetup: "SYSTEM_SETUP",
  OrganisationSetting: "ORGANIZATION_CONFIG",
  ComplianceConfiguration: "PESC49",
  EnergyAnalyticsConfiguration: "PEAC39",
  EnergyAccountingConfiguration: "PECC41",
  PowerQualityConfiguration: "PPQC43",
  PeriodicMaintenanceConfigurationParameters: "PMAC47",
  PeriodicMaintenanceSchedule: "PMAD46",
  Gateways: "PJGF26",
  Devices: "PJDF29",
  DeviceTypes: "PJDF29",
  DeviceLibrary: "PJDL30",
  Assets: "PJAC31",
  Storage: "PSTC80",
  StoragePeriod: "PSTC80",
  Notification: "PJNC36",
  UserManagement: "USER_MANAGEMENT",
  Plantviewcreation: "PJPC24",
  //Dashboardcreation: "PJOB37",
  //Dashboardcreation: "PJDW18",
  DbrdConfiguration: "PJDW18",
  Map: "PJMP34",
  StatusTable: "PMAC47",
  OverviewHomePage: "PMAC47",
  GroupConfiguration: "PJNC36",
  OverviewConfig: "PJOB37",
  AuditConfig: "PAUC71",
  CommissionIntegration: "PAUC71",
  Elogbook: "PRTC59",
};

// 2. Recursively filter tree nodes by permission
function filterTreeByPermission(tree, userPermissions) {
  return tree
    .map((node) => {
      // First, recursively filter children
      const filteredChildren =
        node.child && node.child.length > 0
          ? filterTreeByPermission(node.child, userPermissions)
          : [];

      return {
        ...node,
        child: filteredChildren,
      };
    })
    .filter((node) => {
      // Check if this node has permission
      const required = pagePermissionMap[node.pagename];
      const hasDirectPermission = required
        ? userPermissions?.includes(required)
        : false;

      // Check if node has any accessible children
      const hasAccessibleChildren = node.child && node.child.length > 0;

      // Show node if: user has direct permission OR node has at least one accessible child
      return hasDirectPermission || hasAccessibleChildren;
    });
}
export default function ConfigTreeviewpage() {
  const dispatch = useDispatch();
  const [selecteditemid, setSelecteditemid] = useState("1");
  const { PermissionsArray: usrPrmns } = useSelector(
    (state) => state.logindata.userdetails,
  );
  var path = [];
  const handleitemselected = (event, ids) => {
    path = [];
    setSelecteditemid(ids);
    generateselectedelementpath(ids, configtreejson);
    dispatch(updateconfigtreepathselected(path.reverse()));
  };
  const generateselectedelementpath = (key, tree) => {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.children.length !== 0) {
        if (node.id === key) {
          path.push(node.label);
          return;
        } else {
          generateselectedelementpath(key, node.children);
          if (path.length !== 0) {
            path.push(node.label);
            return;
          }
        }
      } else {
        if (node.id === key) {
          path.push(node.label);
        }
      }
    }
  };

  // 3. Filter the tree before rendering
  const filteredTree = filterTreeByPermission(configtreejson, usrPrmns);

  return (
    <Box
      sx={{
        height: "100%",
        textAlign: "left",
        margin: "10px",
        overflow: "auto",
      }}
    >
      <RichTreeView
        sx={{
          "& MuiTreeItem-group": {
            color: "var(--HighlightedText_Stroke) !important",
            fontWeight: "700 !important",
          },
          "& .Mui-selected:hover": {
            backgroundColor: "transparent !important",
          },
          "& .Mui-selected": {
            backgroundColor: "transparent !important",
            color: "var(--HighlightedText_Stroke) !important",
            fontWeight: "700 !important",
          },
          "& .Mui-focused": {
            backgroundColor: "transparent !important",
            color: "var(--HighlightedText_Stroke) !important",
            fontWeight: "700 !important",
          },
          "& .Mui-selected .MuiTreeItem-content": {
            backgroundColor: "transparent !important",
            color: "var(--HighlightedText_Stroke) !important",
            fontWeight: "700 !important",
          },
          color: "var(--PrimaryText)",
        }}
        items={filteredTree}
        onSelectedItemsChange={handleitemselected}
        defaultSelectedItems={"1"}
        selectedItems={selecteditemid}
      />
    </Box>
  );
}
